export default "__VITE_ASSET__D2gv30j9__"